import { useLazyQuery } from '@apollo/client';
import { GET_FORCED_CHOICE_QUESTIONS } from '../../apollo/queries/forcedChoice';

const useForcedChoiceQuestions = () => {
  const [fetchQuestions, { data, loading, error }] = useLazyQuery(GET_FORCED_CHOICE_QUESTIONS);
  
  return {
    fetchQuestions,
    questionsData: data,
    loading,
    error,
  };
};

export default useForcedChoiceQuestions;